<script setup lang="ts">
defineOptions({ name: "BOMComponentTreeRows" })

type BomTreeNode = {
  component: string
  quantity: string
  unit: string
  unit_cost: string
  line_cost: string
  children: BomTreeNode[]
}

withDefaults(
  defineProps<{
    nodes: BomTreeNode[]
    depth?: number
  }>(),
  {
    depth: 0,
  }
)
</script>

<template>
  <template v-for="(node, index) in nodes" :key="`${node.component}-${index}-${depth}`">
    <tr>
      <td class="px-3 py-2 text-slate-800">
        <div class="flex items-center gap-2" :style="{ paddingLeft: `${depth * 20}px` }">
          <span v-if="depth > 0" class="text-slate-300">|_</span>
          <span class="font-medium">{{ node.component }}</span>
        </div>
      </td>
      <td class="px-3 py-2 text-right text-slate-700">{{ node.quantity }}</td>
      <td class="px-3 py-2 text-center text-slate-700">{{ node.unit }}</td>
      <td class="px-3 py-2 text-right text-slate-700">{{ node.unit_cost }}</td>
      <td class="px-3 py-2 text-right font-medium text-slate-900">{{ node.line_cost }}</td>
    </tr>

    <BOMComponentTreeRows v-if="node.children.length > 0" :nodes="node.children" :depth="depth + 1" />
  </template>
</template>

